import './bootstrap';
import '../css/app.css';

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/vue.m';
import GlobalHelpersPlugin from "@/plugins/global-helpers.js";
import Pagination from '@/Components/Pagination.vue';
import VueTheMask from 'vue-the-mask';
import PrivilegesPlugin from '@/plugins/privileges-plugin.js';
import * as Sentry from "@sentry/vue";

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, app, props, plugin }) {
        const vueApp = createApp({ render: () => h(app, props) })
            .use(plugin)
            .use(ZiggyVue, Ziggy)
            .use(PrivilegesPlugin)
            .use(VueTheMask)
            .use(GlobalHelpersPlugin)
            .component('pagination', Pagination);

        const authenticatedUser = props?.initialPage?.props?.auth?.user ?? null;

        if(authenticatedUser) {
            Sentry.setUser({
                id: authenticatedUser.data.id,
                username: `${authenticatedUser.data.full_name} (${authenticatedUser.data.id}#${authenticatedUser.data.email})`,
                email: authenticatedUser.data.email,
            });
        }

        Sentry.setTag('system', 'frontend');

        Sentry.init({
            vueApp,
            dsn: import.meta.env.VITE_SENTRY_VUE_DSN,
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.replayIntegration({
                    maskAllText: false,
                    maskAllInputs: false,
                    blockAllMedia: false,
                }),
            ],
            // Performance Monitoring
            tracesSampleRate: 1.0, //  Capture 100% of the transactions
            // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
            // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
            // Session Replay
            replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
            replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        });

        vueApp.mount(el);

        return vueApp;
    },
});

InertiaProgress.init({ color: '#ff7700' });
